// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#AdminOpsTenant {
  justify-content: flex-start;
}
#AdminOpsTenant .ops-tenant-create-button {
  min-width: 160px;
}
#AdminOpsTenant .ops-tenant-body {
  width: 100%;
  height: calc(100vh - var(--page-header-height));
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  padding: 0 16px 60px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
#AdminOpsTenant .ops-tenant-input {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
#AdminOpsTenant .ops-tenant-input + .ops-tenant-input {
  margin-top: 12px;
}
#AdminOpsTenant .ops-tenant-input-label {
  font-size: 12px;
  font-weight: 700;
  color: var(--font_active_sub_color);
}
#AdminOpsTenant .ops-tenant-text {
  width: 360px;
  max-width: 100%;
}
#AdminOpsTenant .ops-tenant-text.is-error .textinput {
  border-color: var(--ops-error);
}
#AdminOpsTenant .ops-tenant-operator-email {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 12px;
}
#AdminOpsTenant .ops-tenant-operator-email code {
  font-family: var(--ops-mono);
  font-size: 14px;
  word-break: break-all;
}
#AdminOpsTenant .ops-tenant-password {
  width: 360px;
  max-width: 100%;
}
#AdminOpsTenant .ops-tenant-password .ops-tenant-text {
  width: 100%;
}
#AdminOpsTenant .ops-tenant-password .has-regenerate-button {
  padding-right: 40px;
}
#AdminOpsTenant .ops-tenant-regenerate {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 4px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  min-height: 32px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background-color: transparent;
  color: var(--font_active_sub_color);
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
}
#AdminOpsTenant .ops-tenant-regenerate:hover {
  background-color: var(--color-bg);
  color: var(--primary-color-main);
}
#AdminOpsTenant .ops-tenant-uncertain {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px 20px;
  border-radius: 8px;
  border: 1px solid var(--ops-warn-border);
  background: var(--ops-warn-bg);
  color: var(--ops-warn-text);
  font-size: 13px;
  text-align: left;
}
#AdminOpsTenant .ops-tenant-uncertain code {
  font-family: var(--ops-mono);
  font-weight: 700;
}
#AdminOpsTenant .ops-tenant-uncertain-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: 14px;
}
#AdminOpsTenant .ops-tenant-result {
  background: var(--white-color-lightest);
  border-radius: 8px;
  padding: 32px;
  box-sizing: border-box;
  border-left: 4px solid var(--success-color-main);
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: left;
}
#AdminOpsTenant .ops-tenant-result-head {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
#AdminOpsTenant .ops-tenant-result-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  color: var(--ops-inuse-fg);
}
#AdminOpsTenant .ops-tenant-result-title .bi {
  font-size: 18px;
}
#AdminOpsTenant .ops-tenant-result-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  background: var(--ops-inuse-bg);
  color: var(--ops-inuse-fg);
  border: 1px solid var(--ops-inuse-border);
}
#AdminOpsTenant .ops-tenant-result-summary {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 14px;
}
#AdminOpsTenant .ops-tenant-result-summary span {
  display: inline-block;
  width: 96px;
  color: var(--font_active_sub_color);
  font-size: 12px;
}
#AdminOpsTenant .ops-tenant-result-warning {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 6px;
  background: var(--ops-warn-bg);
  border: 1px solid var(--ops-warn-border);
  color: var(--ops-warn-text);
  font-size: 13px;
  font-weight: 600;
}
#AdminOpsTenant .ops-tenant-memo {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
#AdminOpsTenant .ops-tenant-memo-head {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
#AdminOpsTenant .ops-tenant-memo-title {
  font-size: 13px;
  font-weight: 700;
}
#AdminOpsTenant .ops-tenant-memo-copy {
  min-height: 32px;
  padding: 4px 14px;
  border-radius: 8px;
  border: 1px solid var(--border-color);
  background: transparent;
  color: var(--font_active_sub_color);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
}
#AdminOpsTenant .ops-tenant-memo-copy:hover {
  background: var(--dark-color-dark-transparent-10);
}
#AdminOpsTenant .ops-tenant-memo-text {
  margin: 0;
  font-size: 13px;
  font-family: var(--ops-mono);
  color: var(--dark-color-dark);
  white-space: pre-wrap;
  word-break: break-all;
  background: var(--input-bg-color);
  border-radius: 6px;
  padding: 12px;
}
#AdminOpsTenant .ops-tenant-result-actions {
  display: flex;
  flex-direction: row;
  gap: 12px;
  flex-wrap: wrap;
}
#AdminOpsTenant .ops-tenant-result-btn {
  min-height: 40px;
  padding: 8px 20px;
  border-radius: 8px;
  border: 1px solid var(--border-color);
  background: transparent;
  color: var(--font_active_sub_color);
  font-weight: 600;
  letter-spacing: 1px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}
#AdminOpsTenant .ops-tenant-result-btn .bi {
  font-size: 16px;
}
#AdminOpsTenant .ops-tenant-result-btn:hover {
  background: var(--dark-color-dark-transparent-10);
}
#AdminOpsTenant .ops-tenant-result-btn.is-primary {
  border-color: var(--primary-color-main);
  background: var(--primary-color-main);
  color: var(--white-color-light);
}
#AdminOpsTenant .ops-tenant-result-btn.is-primary:hover {
  background: var(--primary-color-dark);
  border-color: var(--primary-color-dark);
}

#ops-tenant-confirm-modal .ev-modal-container {
  width: 560px;
  max-width: calc(100vw - 48px);
}
#ops-tenant-confirm-modal .ops-tenant-confirm {
  width: 100%;
  text-align: left;
  color: var(--dark-color-dark);
}
#ops-tenant-confirm-modal .ops-tenant-confirm-list {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--border-weak-color);
  border-radius: 6px;
  overflow: hidden;
}
#ops-tenant-confirm-modal .ops-tenant-confirm-list > div {
  padding: 10px 12px;
  border-top: 1px solid #edeef1;
  word-break: break-all;
}
#ops-tenant-confirm-modal .ops-tenant-confirm-list > div:first-child {
  border-top: none;
}
#ops-tenant-confirm-modal .ops-tenant-confirm-list span {
  display: inline-block;
  width: 96px;
  font-weight: 700;
}
#ops-tenant-confirm-modal .ops-tenant-confirm-note {
  font-size: 12px;
  color: var(--danger-color-main);
}`, "",{"version":3,"sources":["webpack://./src/components/admin/parts/ops/AdminOpsTenant.scss"],"names":[],"mappings":"AACA;EACI,2BAAA;AAAJ;AAEI;EACI,gBAAA;AAAR;AAGI;EACI,WAAA;EACA,+CAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AADR;AAII;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AAFR;AAIQ;EACI,gBAAA;AAFZ;AAMI;EACI,eAAA;EACA,gBAAA;EACA,mCAAA;AAJR;AAOI;EACI,YAAA;EACA,eAAA;AALR;AAOQ;EACI,8BAAA;AALZ;AAUI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AARR;AAUQ;EACI,4BAAA;EACA,eAAA;EACA,qBAAA;AARZ;AAaI;EACI,YAAA;EACA,eAAA;AAXR;AAaQ;EACI,WAAA;AAXZ;AAcQ;EACI,mBAAA;AAZZ;AAgBI;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,mCAAA;EACA,eAAA;EACA,6CAAA;AAdR;AAgBQ;EACI,iCAAA;EACA,gCAAA;AAdZ;AAmBI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;AAjBR;AAmBQ;EACI,4BAAA;EACA,gBAAA;AAjBZ;AAqBI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;AAnBR;AAuBI;EACI,uCAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,gDAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AArBR;AAwBI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAtBR;AAyBI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,0BAAA;AAvBR;AAyBQ;EACI,eAAA;AAvBZ;AA2BI;EACI,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,0BAAA;EACA,yCAAA;AAzBR;AA4BI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;AA1BR;AA4BQ;EACI,qBAAA;EACA,WAAA;EACA,mCAAA;EACA,eAAA;AA1BZ;AA8BI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,wCAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;AA5BR;AA+BI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AA7BR;AAgCI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AA9BR;AAiCI;EACI,eAAA;EACA,gBAAA;AA/BR;AAkCI;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qCAAA;EACA,uBAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAhCR;AAkCQ;EACI,iDAAA;AAhCZ;AAoCI;EACI,SAAA;EACA,eAAA;EACA,4BAAA;EACA,6BAAA;EACA,qBAAA;EACA,qBAAA;EACA,iCAAA;EACA,kBAAA;EACA,aAAA;AAlCR;AAqCI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAnCR;AAuCI;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qCAAA;EACA,uBAAA;EACA,mCAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AArCR;AAuCQ;EACI,eAAA;AArCZ;AAwCQ;EACI,iDAAA;AAtCZ;AAyCQ;EACI,uCAAA;EACA,qCAAA;EACA,+BAAA;AAvCZ;AAyCY;EACI,qCAAA;EACA,uCAAA;AAvChB;;AA+CI;EACI,YAAA;EACA,6BAAA;AA5CR;AA+CI;EACI,WAAA;EACA,gBAAA;EACA,6BAAA;AA7CR;AAgDI;EACI,aAAA;EACA,sBAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;AA9CR;AAgDQ;EACI,kBAAA;EACA,6BAAA;EACA,qBAAA;AA9CZ;AAgDY;EACI,gBAAA;AA9ChB;AAkDQ;EACI,qBAAA;EACA,WAAA;EACA,gBAAA;AAhDZ;AAoDI;EACI,eAAA;EACA,+BAAA;AAlDR","sourcesContent":["// テナント作成（フォームの行は OpsCommon.scss の ops-setting-*、完了カードはデモページ作成と同じ見た目）\n#AdminOpsTenant {\n    justify-content: flex-start;\n\n    .ops-tenant-create-button {\n        min-width: 160px;\n    }\n\n    .ops-tenant-body {\n        width: 100%;\n        height: calc(100vh - var(--page-header-height));\n        overflow-y: auto;\n        overflow-x: hidden;\n        box-sizing: border-box;\n        padding: 0 16px 60px;\n        display: flex;\n        flex-direction: column;\n        gap: 16px;\n    }\n\n    .ops-tenant-input {\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n\n        & + .ops-tenant-input {\n            margin-top: 12px;\n        }\n    }\n\n    .ops-tenant-input-label {\n        font-size: 12px;\n        font-weight: 700;\n        color: var(--font_active_sub_color);\n    }\n\n    .ops-tenant-text {\n        width: 360px;\n        max-width: 100%;\n\n        &.is-error .textinput {\n            border-color: var(--ops-error);\n        }\n    }\n\n    // 運営用メール（管理者のメール＋名前）の表示\n    .ops-tenant-operator-email {\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n        margin-top: 12px;\n\n        code {\n            font-family: var(--ops-mono);\n            font-size: 14px;\n            word-break: break-all;\n        }\n    }\n\n    // パスワード入力欄と再生成ボタンを重ねる（ユーザー管理の追加フォームと同じ）\n    .ops-tenant-password {\n        width: 360px;\n        max-width: 100%;\n\n        .ops-tenant-text {\n            width: 100%;\n        }\n\n        .has-regenerate-button {\n            padding-right: 40px;\n        }\n    }\n\n    .ops-tenant-regenerate {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        right: 4px;\n        margin: auto;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 32px;\n        height: 32px;\n        min-height: 32px;\n        padding: 0;\n        border: none;\n        border-radius: 4px;\n        background-color: transparent;\n        color: var(--font_active_sub_color);\n        cursor: pointer;\n        transition: background-color 0.2s, color 0.2s;\n\n        &:hover {\n            background-color: var(--color-bg);\n            color: var(--primary-color-main);\n        }\n    }\n\n    // 通信失敗（作成済みの可能性がある）\n    .ops-tenant-uncertain {\n        display: flex;\n        flex-direction: column;\n        gap: 6px;\n        padding: 16px 20px;\n        border-radius: 8px;\n        border: 1px solid var(--ops-warn-border);\n        background: var(--ops-warn-bg);\n        color: var(--ops-warn-text);\n        font-size: 13px;\n        text-align: left;\n\n        code {\n            font-family: var(--ops-mono);\n            font-weight: 700;\n        }\n    }\n\n    .ops-tenant-uncertain-title {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        font-weight: 700;\n        font-size: 14px;\n    }\n\n    // 完了カード\n    .ops-tenant-result {\n        background: var(--white-color-lightest);\n        border-radius: 8px;\n        padding: 32px;\n        box-sizing: border-box;\n        border-left: 4px solid var(--success-color-main);\n        display: flex;\n        flex-direction: column;\n        gap: 16px;\n        text-align: left;\n    }\n\n    .ops-tenant-result-head {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n        gap: 16px;\n    }\n\n    .ops-tenant-result-title {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        font-weight: 700;\n        color: var(--ops-inuse-fg);\n\n        .bi {\n            font-size: 18px;\n        }\n    }\n\n    .ops-tenant-result-badge {\n        display: inline-flex;\n        align-items: center;\n        padding: 3px 10px;\n        border-radius: 999px;\n        font-size: 11px;\n        font-weight: 700;\n        background: var(--ops-inuse-bg);\n        color: var(--ops-inuse-fg);\n        border: 1px solid var(--ops-inuse-border);\n    }\n\n    .ops-tenant-result-summary {\n        display: flex;\n        flex-direction: column;\n        gap: 6px;\n        font-size: 14px;\n\n        span {\n            display: inline-block;\n            width: 96px;\n            color: var(--font_active_sub_color);\n            font-size: 12px;\n        }\n    }\n\n    .ops-tenant-result-warning {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        padding: 10px 12px;\n        border-radius: 6px;\n        background: var(--ops-warn-bg);\n        border: 1px solid var(--ops-warn-border);\n        color: var(--ops-warn-text);\n        font-size: 13px;\n        font-weight: 600;\n    }\n\n    .ops-tenant-memo {\n        display: flex;\n        flex-direction: column;\n        gap: 6px;\n    }\n\n    .ops-tenant-memo-head {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n        gap: 12px;\n    }\n\n    .ops-tenant-memo-title {\n        font-size: 13px;\n        font-weight: 700;\n    }\n\n    .ops-tenant-memo-copy {\n        min-height: 32px;\n        padding: 4px 14px;\n        border-radius: 8px;\n        border: 1px solid var(--border-color);\n        background: transparent;\n        color: var(--font_active_sub_color);\n        font-size: 13px;\n        font-weight: 600;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        gap: 6px;\n\n        &:hover {\n            background: var(--dark-color-dark-transparent-10);\n        }\n    }\n\n    .ops-tenant-memo-text {\n        margin: 0;\n        font-size: 13px;\n        font-family: var(--ops-mono);\n        color: var(--dark-color-dark);\n        white-space: pre-wrap;\n        word-break: break-all;\n        background: var(--input-bg-color);\n        border-radius: 6px;\n        padding: 12px;\n    }\n\n    .ops-tenant-result-actions {\n        display: flex;\n        flex-direction: row;\n        gap: 12px;\n        flex-wrap: wrap;\n    }\n\n    // デモページ作成の完了カードのボタンと同じ見た目（is-primary は塗り）\n    .ops-tenant-result-btn {\n        min-height: 40px;\n        padding: 8px 20px;\n        border-radius: 8px;\n        border: 1px solid var(--border-color);\n        background: transparent;\n        color: var(--font_active_sub_color);\n        font-weight: 600;\n        letter-spacing: 1px;\n        font-size: 14px;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n\n        .bi {\n            font-size: 16px;\n        }\n\n        &:hover {\n            background: var(--dark-color-dark-transparent-10);\n        }\n\n        &.is-primary {\n            border-color: var(--primary-color-main);\n            background: var(--primary-color-main);\n            color: var(--white-color-light);\n\n            &:hover {\n                background: var(--primary-color-dark);\n                border-color: var(--primary-color-dark);\n            }\n        }\n    }\n}\n\n// 作成確認（入力内容の一覧）\n#ops-tenant-confirm-modal {\n    .ev-modal-container {\n        width: 560px;\n        max-width: calc(100vw - 48px);\n    }\n\n    .ops-tenant-confirm {\n        width: 100%;\n        text-align: left;\n        color: var(--dark-color-dark);\n    }\n\n    .ops-tenant-confirm-list {\n        display: flex;\n        flex-direction: column;\n        border: 1px solid var(--border-weak-color);\n        border-radius: 6px;\n        overflow: hidden;\n\n        > div {\n            padding: 10px 12px;\n            border-top: 1px solid #edeef1;\n            word-break: break-all;\n\n            &:first-child {\n                border-top: none;\n            }\n        }\n\n        span {\n            display: inline-block;\n            width: 96px;\n            font-weight: 700;\n        }\n    }\n\n    .ops-tenant-confirm-note {\n        font-size: 12px;\n        color: var(--danger-color-main);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
